// extracted by mini-css-extract-plugin
module.exports = {"resultsDisplay":"ResultsDisplay_resultsDisplay__1RDKv","result":"ResultsDisplay_result__k6NSN","btn":"ResultsDisplay_btn__2Cg5u"};